import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ImageIcon from "@material-ui/icons/ImageRounded";
import PropTypes from "prop-types";
import React from "react";
import Resizer from "react-image-file-resizer";
import { store as storeNotification } from "react-notifications-component";
import SwipeableViews from "react-swipeable-views";
import DocAccess from "../DocAccess";
import Drawing from "./Drawing";
import TextEditors from "./TextEditors";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		"aria-controls": `full-width-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		width: 500,
	},
	appBar: {
		position: "relative",
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenDialog = (props, ref) => {
	console.log("handleClickOpen Open=", props.openDialog);
	const classes = useStyles();

	const theme = useTheme();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		handleSign("");
		setValue(newValue);
	};

	const handleChangeIndex = (index) => {
		setValue(index);
	};
	const [open, setOpen] = React.useState(props.openDialog);

	if (props.openDialog === false) return <></>;

	const handleSign = async (value) => {
		console.log("handleSign value =", value);
		await props.onHandleSignChange(value);
	};

	return (
		<div>
			<Dialog
				//fullScreen
				open={open}
				onClose={props.handleClose}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={props.handleClose}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Document
						</Typography>
						{!props.dontShowSaveButton && (
							<Button autoFocus color="inherit" onClick={props.handleSaveText}>
								save
							</Button>
						)}
					</Toolbar>
				</AppBar>
				<List>
					<ListItem button>
						<ListItemText
							primary={props.firstText}
							secondary={props.secondText}
						/>
					</ListItem>
					<Divider />
				</List>
				{!props.dontShowCommentText && (
					<TextEditors
						onHandleDocBodyChange={props.onHandleDocBodyChange}
						onHandleDocTitleChange={props.onHandleDocTitleChange}
						docBody={props.docBody}
						docTitle={props.docTitle}
						showInputText={props.showInputText}
					/>
				)}
				{props.showDocUserAccess && <DocAccess data={props.data} />}
				<Divider />
				{props.showDrawing && (
					<>
						<Paper square>
							<Tabs
								value={value}
								indicatorColor="primary"
								textColor="primary"
								onChange={handleChange}
								aria-label="disabled tabs example"
							>
								<Tab label="Hand Sign" {...a11yProps(0)} />
								<Tab label="Upload Signature" {...a11yProps(1)} />
							</Tabs>
						</Paper>
						<SwipeableViews
							axis={theme.direction === "rtl" ? "x-reverse" : "x"}
							index={value}
							onChangeIndex={handleChangeIndex}
						>
							<TabPanel value={value} index={0} dir={theme.direction}>
								<div id="drawingDv">
									<Drawing handleChange={(value) => handleSign(value)} />
								</div>
							</TabPanel>
							<TabPanel value={value} index={1} dir={theme.direction}>
								<div id="drawingDv">
									<SignatureUpload
										handleChange={(value) => handleSign(value)}
									/>
								</div>
							</TabPanel>
						</SwipeableViews>
					</>
				)}
			</Dialog>
		</div>
	);
};

const SignatureUpload = (props) => {
	const [image, setImage] = React.useState();
	const onChange = (event) => {
		console.log(
			"SignatureUpload event.target.files[0]=",
			event.target.files[0]
		);
		if(event.target.files[0].size>1024 * 1024)
		{
			storeNotification.addNotification({
				title: "signatue!",
				message: "Signature image is too big! the current size is "+(event.target.files[0].size/(1024* 1024)).toFixed(2)+"Mb! it should not be greater than 1Mb",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return;
		}

		/*getBase64(event.target.files[0]).then((data) => {
			console.log("SignatureUpload getBase64 image=", data);
			setImage(data);
		});
		*/
		Resizer.imageFileResizer(
			event.target.files[0],
			200,
			200,
			"JPEG",
			100,
			0,
			(uri) => {
				console.log("new url size ", uri);
				setImage(uri);
				props.handleChange(uri);
			},
			"base64",
			200,
			200
		);
	};
	return (
		<React.Fragment>
			<input
				color="primary"
				accept="image/*"
				type="file"
				onChange={onChange}
				id="icon-button-file"
				style={{ display: "none" }}
			/>
			<label htmlFor="icon-button-file">
				<Button
					variant="contained"
					component="span"
					//className={classes.button}
					size="large"
					color="primary"
				>
					<ImageIcon />
				</Button>
			</label>
			{image && <img src={image} width="200" height="200" />}
		</React.Fragment>
	);
};

export default React.forwardRef(FullScreenDialog);
